import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
/**
 * @deprecated Renamed from VeltCommentDialogSuggestionAction* on 2026-07-20 to mirror the SDK's legacy rename
 * (velt-comment-dialog-legacy-suggestion-action*). Unreachable inside dialogs; kept for standalone usage.
 */
var VeltCommentDialogLegacySuggestionActionReject = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-legacy-suggestion-action-reject-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogLegacySuggestionActionReject;
